/**
 * EventEmitter - A simple class for managing event callbacks.
 * @category Experience
 * @subcategory Utils
 */
export default class EventEmitter {
    /**
     * Constructs the EventEmitter class.
     * Initializes an object to store event callbacks.
     */
    constructor() {
        /**
         * @property {Object} callbacks - A map of event names to their associated callbacks.
         */
        this.callbacks = {};
    }

    cleanup() {
        this.callbacks = {}; // Clear all registered event callbacks
        console.log("EventEmitter cleaned up. All event listeners removed.");
    }

    /**
     * Registers a callback for a specific event.
     * @param {string} event - The name of the event to listen for.
     * @param {Function} callback - The callback function to execute when the event is triggered.
     */
    on(event, callback) {
        if (!this.callbacks[event]) {
            this.callbacks[event] = [];
        }
        this.callbacks[event].push(callback);
    }

    /**
     * Triggers an event and executes all registered callbacks for it.
     * @param {string} event - The name of the event to trigger.
     * @param {...any} args - Arguments to pass to the callback functions.
     */
    trigger(event, ...args) {
        if (this.callbacks[event]) {
            this.callbacks[event].forEach(callback => {
                callback(...args);
            });
        }
    }
}
